export const getMakeTransferMessageTitleKey = (
  partyNameMatch
) =>
  `transfer-send_transfer_${partyNameMatch.toLowerCase()}_title`;

export const getMakeTransferMessageContentKey = (
  partyNameMatch,
) =>
  `transfer-send_transfer_${partyNameMatch.toLowerCase()}_description`;
export const getConfirmationScreenMessageTitleKey = (
    partyNameMatch
) =>
    `transfer-confirm_transfer_${partyNameMatch.toLowerCase()}_title`;

export const getConfirmationMessageContentKey = (
    partyNameMatch,
) =>
    `transfer-confirm_transfer_${partyNameMatch.toLowerCase()}_description`;
